import { values } from 'lodash/fp';
import React from 'react';

import { getContent } from '../../src/client/pages/insurance/content';
import { INSURANCE_TYPES } from '../../src/client/pages/insurance/constants';
import combineContentWithCmsData from '../../src/client/pages/insurance/utils/combine-content-with-cms-data';
import constants from '../../src/client/ahm-constants';
import getInsuranceTypeProps from '../utils/get-insurance-type-props';
import getShouldSkipClientSideRequest from '../../src/client/utils/get-should-skip-client-side-request';
import getStaticPathsForInsuranceTypes from './utils/get-static-paths-for-insurance-types';
import InsurancePage, { type InsurancePageProps } from '../../src/client/pages/insurance';
import RedirectAdapter from '../../src/client/utils/redirect-adapter';
import useGetInsuranceType from '../../src/client/pages/insurance/hooks/use-get-insurance-type';

const { URLS } = constants;

const LandingPage = ({ content, insuranceType }: InsurancePageProps) => {
  const shouldSkip = getShouldSkipClientSideRequest();

  // refetch content for time travel
  const { data: clientSideCmsData, hasError, isLoading } = useGetInsuranceType({ insuranceType, shouldSkip });

  if (hasError) {
    return <RedirectAdapter to={URLS.SALES.ERROR_500} />;
  }

  const staticContent = getContent(insuranceType);
  const combinedContent = shouldSkip
    ? content
    : combineContentWithCmsData({ cmsData: clientSideCmsData, staticContent });

  return <InsurancePage insuranceType={insuranceType} content={isLoading ? content : combinedContent} />;
};
export const getStaticPaths = () => getStaticPathsForInsuranceTypes(values(INSURANCE_TYPES));

export const getStaticProps = getInsuranceTypeProps;

export default LandingPage;
